import { CommonModule } from '@angular/common';
import { Component, inject, Injector, Input, Signal, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatExpansionModule } from '@angular/material/expansion';
import {
  COMPANY_PROFILE_CARD_DATA_TOKEN,
  CompanyProfileCardData,
  CrmPlatformApiService,
  ProfileCard,
  CompanyProfileCardsPanelService,
} from '@galaxy/crm/static';

@Component({
  selector: 'crm-company-profile-cards-panel',
  imports: [CommonModule, MatExpansionModule],
  templateUrl: './company-profile-cards-panel.component.html',
  styleUrls: ['./company-profile-cards-panel.component.scss'],
  providers: [CrmPlatformApiService, CompanyProfileCardsPanelService],
})
export class CompanyProfileCardsPanelComponent {
  private _company!: CompanyProfileCardData;
  @Input({ required: true })
  public get company(): CompanyProfileCardData {
    return this._company;
  }

  public set company(value: CompanyProfileCardData) {
    this._company = value;
    this.cardData.set(
      Injector.create({
        providers: [
          {
            provide: COMPANY_PROFILE_CARD_DATA_TOKEN,
            useValue: {
              company_id: value.company_id,
              account_group_id: value.account_group_id,
              name: value.name,
              group_id: value.group_id,
            },
          },
        ],
        parent: this.injector,
      }),
    );
  }

  cards: Signal<ProfileCard[] | undefined>;

  private readonly injector = inject(Injector);
  cardData: WritableSignal<Injector | undefined> = signal(undefined);

  constructor(companyProfileCardsPanelService: CompanyProfileCardsPanelService) {
    this.cards = toSignal(companyProfileCardsPanelService.companyProfileCards$);
  }
}
